import { createSlice } from "@reduxjs/toolkit";

export const defaultImageAnalysisState = {
  uid: "",
  imageInfo: []
}

export const imageAnalysisSlice = createSlice({
  name: "imageAnalysis",
  initialState: {},
  reducers: {
    setAnalysisData(state, action) {
      const { imageName, data } = action.payload;
      state[imageName] = data;
    },
    resetImageAnalysisState(state, action) {
      Object.keys(state).map(r => {
        delete state[r]
      })
    },
    removeBlurredImage(state, action) {
      delete state[action.payload];
    }
  }
})